import { Popconfirm as ANTPopconfirm, PopconfirmProps } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../Button/Button";

interface IPopconfirmProps extends PopconfirmProps {
  buttonName?: string;
  buttonText?: string;
  buttonType?: "link" | "text" | "default" | "primary" | "dashed";
  title: string;
  disabled?: any;
  className?: any;
  children?: any;
  onConfirm?: (e: any) => any;
  loading?: any;
}

export const PopconfirmButton: React.FC<IPopconfirmProps> = ({
  buttonName,
  buttonType,
  buttonText,
  className,
  disabled,
  title,
  onConfirm,
  children,
  loading,
}) => {
  const { t } = useTranslation();
  const translatedTitle = t("POPCONFIRM.TITLE", { text: title });

  return (
    <ANTPopconfirm
      title={translatedTitle}
      onConfirm={onConfirm}
      onCancel={(e) => e?.stopPropagation()}
      okText={t("COMMON.DA")}
      cancelText={t("COMMON.NE")}
    >
      {children ? (
        children
      ) : (
        <Button
          className={className}
          disabled={disabled}
          name={buttonName}
          type={buttonType}
        >
          {buttonText}
        </Button>
      )}
    </ANTPopconfirm>
  );
};
